/** What each kind of money movement is called on screen. */
export const SOURCE_LABELS: Record<string, string> = {
  sale: 'Customer payment',
  sale_void: 'Voided sale',
  refund: 'Refund',
  expense: 'Expense paid',
  expense_reversal: 'Deleted expense returned',
  opening_balance_payment: 'Old debt repaid',
  loan: 'Loan',
  remittance: 'Rider remittance',
  hire_purchase: 'Hire purchase',
  settlement: 'Rider settlement',
  transfer: 'Transfer',
  rider_return: 'Cash returned by rider',
  rider_payout: 'Rider payout',
  rider_collection: 'Collected by rider (out of till)',
  investor_payout: 'Investor payout',
  investment_payment: 'Dividend / profit share paid',
};
